import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Loading from "../../../components/Loading";

dayjs.extend(relativeTime);

const PriorityListWidget = ({ priorityList, loading }) => {
  if (loading) return <div className="recap-card"><Loading type="small" /></div>;

  return (
    <div className="recap-card recap-card--priority">
      <div className="recap-card__header">
        <h3 className="recap-card__title">
          Priority List
        </h3>
        {priorityList.length > 0 && (
          <span className="recap-card__badge recap-card__badge--urgent">
            {priorityList.length} waiting
          </span>
        )}
      </div>

      <p className="recap-card__subtitle">
        Clients waiting &gt;30 min with no reply
      </p>

      {priorityList.length === 0 ? (
        <div className="recap-card__empty-state">
          <span className="recap-card__empty-state-icon">&#10003;</span>
          <p className="recap-card__empty">No one waiting — you're on top of it</p>
        </div>
      ) : (
        <div className="recap-card__list recap-card__list--scrollable">
          {priorityList.map((msg, i) => {
            const waitingFor = dayjs.unix(msg.timestamp).fromNow(true);
            return (
              <div key={i} className="recap-card__list-item recap-card__list-item--urgent">
                <div className="recap-card__list-item-content">
                  <span className="recap-card__list-item-name">
                    {msg.sender?.wa_name || msg.sender?.phone || msg.chat_title}
                  </span>
                  <span className="recap-card__list-item-sub">
                    {msg.sender?.phone || ""}
                  </span>
                </div>
                <span className="recap-card__wait-time">
                  {waitingFor} waiting
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PriorityListWidget;
